import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';
import { saveInquiry } from '@spectee/graphql/mutations';

const document = gql(saveInquiry);

export function useSaveInquiry() {
  return useMutation(document);
}
